import { AddEditLinkProperty, BaseControlOption, ReadOnlyIf, ReadOnlyProperty, RequiredIf, RequiredValidator, ValueProperty, VisibleProperty } from '../control-options/control-option.interface';

export class BaseControl {

  id: string;
  options: BaseControlOption[];
  label: string;
  loaded: boolean = false;
  className: string;

  constructor(id: string, label: string, ...options: BaseControlOption[]) {
    this.id = id;
    this.label = label;

    var opts = options[0] as Array<BaseControlOption>;
    var o = opts[0] as Array<BaseControlOption>;

    this.options = o;
  }

  get hasValue(): boolean {

    var value = Reflect.get(this, 'value');
    if (value !== undefined && value !== null && value !== "") {
      return true;
    }

    return false;
  }

  get isReadOnly(): boolean {

    if (this.options) {
      var prop = this.options.ofType<ReadOnlyProperty>(ReadOnlyProperty)[0];
      if (prop) {
        return prop.value;
      }
      var ifProp = this.options.ofType<ReadOnlyIf>(ReadOnlyIf)[0];
      if (ifProp) {
        return ifProp.evaluate();
      }
    }

    return false;
  }

  get isRequired(): boolean {
    if (this.options) {
      var prop = this.options.ofType<RequiredValidator>(RequiredValidator)[0];
      if (prop) {
        return prop.validate(this);
      }
      var ifProp = this.options.ofType<RequiredIf>(RequiredIf)[0];
      if (ifProp) {
        return ifProp.evaluate();
      }
    }

    return false;
  }

  get isVisible(): boolean {

    if (this.options) {
      var prop = this.options.ofType<VisibleProperty>(VisibleProperty)[0];
      if (prop) {
        return prop.evaluate();
      }
    }

    return true;
  }

  get includeAddEditLink(): boolean {

    if (this.options) {
      var prop = this.options.ofType<AddEditLinkProperty>(AddEditLinkProperty)[0];
      if (prop) {
        return true;
      }
    }

    return false;
  }

  get addEditLink(): string {

    if (this.includeAddEditLink) {
      var prop = this.options.ofType<AddEditLinkProperty>(AddEditLinkProperty)[0];
      if (prop) {
        return prop.value;
      }
    }

    return "";

  }
}

type Constructor<T> = new (...args: any[]) => T;

function ofType<TElements, T extends TElements>(this: TElements[], filterType: Constructor<T>): T[] {
  return <T[]>this.filter(e => e instanceof filterType);
}

// Declare the extension
declare global {
  interface Array<T> {
    ofType<T>(filterType: Constructor<T>): T[];
  }
}

// Implement extension
Array.prototype.ofType = ofType;
